<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import { NuxtLink } from '#components'

const props = defineProps<{
  code: string
  icon: string
  companyName?: string
  class?: HTMLAttributes['class']
  to?: RouteLocationRaw | string
}>()

const { isMobile } = useBreakpoints()
</script>
<template>
  <component
    :is="to ? NuxtLink : 'div'"
    :to="to"
    :class="
      cn(
        'flex-none flex items-center p-0.5 relative before:absolute before:inset-0 before:rounded-xl before:shadow-xs before:-scale-y-100 transition-all justify-center rounded-xl shadow-md dark:bg-surface-container-highest',
        {
          'hover:shadow-xl': to
        }
      )
    "
  >
    <Icon
      :name="icon"
      :alt="companyName"
      :size="isMobile ? '44px' : '68px'"
      :class="cn(props.class, 'dark:text-inherit')"
    />
  </component>
</template>
